enum AudioImplementation {
  WebAudio = "Web Audio API",
  Binaural = "BinauralFIR",
  ResonanceAudio = "Resonance Audio"
}

export default AudioImplementation;
